// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__19NRo","title":"Info_title__I30rc","links":"Info_links__2fxlJ","link":"Info_link__1DyUL","logo":"Info_logo__3SF8J"};